<div *ngIf="metrics" class="lab-results-wrapper">
	<section class="section-wrapper">
		<div>
			<div class="section-block">
				<div class="section-block-header" [translate]="'wellness.lab-results.total-cholesterol'">Total Cholesterol</div>
				<div class="row section-block-content">
					<div class="col-md-12">
						<span class="last-update-on" *ngIf="chartType.hasOwnProperty('Total Cholesterol')">
							UPDATED: {{ chartType['Total Cholesterol'].attributeUpdatedDate }}
						</span>
					</div>
					<div [className]="appUtil.isScreenSizeIpad() ? 'col-md-4' : 'col-md-3'">
						<app-progress-bar
							class="Total-Cholesterol"
							*ngIf="chartType.hasOwnProperty('Total Cholesterol') && renderCharts === true"
							[chartData]="chartType['Total Cholesterol']"></app-progress-bar>
					</div>
					<div [className]="appUtil.isScreenSizeIpad() ? 'col-md-8' : 'col'">
						<span *ngIf="chartType.hasOwnProperty('Total Cholesterol') !== true">
							Your lab results are not available
						</span>
						<p *ngIf="chartType.hasOwnProperty('Total Cholesterol')">
							{{ chartType['Total Cholesterol'].metricDescription }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="section-wrapper">
		<div>
			<div class="section-block">
				<div class="section-block-header" [translate]="'wellness.lab-results.bad-cholesterol'">
					LDL "Bad" Cholesterol
				</div>
				<div class="row section-block-content">
					<div class="col-md-12">
						<span class="last-update-on" *ngIf="chartType.hasOwnProperty('LDL')">
							UPDATED: {{ chartType['LDL'].attributeUpdatedDate }}
						</span>
					</div>
					<div [className]="appUtil.isScreenSizeIpad() ? 'col-md-4' : 'col-md-3'">
						<app-progress-bar
							class="LDL"
							*ngIf="chartType.hasOwnProperty('LDL') && renderCharts === true"
							[chartData]="chartType['LDL']"></app-progress-bar>
					</div>
					<div [className]="appUtil.isScreenSizeIpad() ? 'col-md-8' : 'col'">
						<span *ngIf="chartType.hasOwnProperty('LDL') !== true"> Your lab results are not available </span>
						<p *ngIf="chartType.hasOwnProperty('LDL')">{{ chartType['LDL'].metricDescription }}</p>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="section-wrapper">
		<div>
			<div class="section-block">
				<div class="section-block-header" [translate]="'wellness.lab-results.good-cholesterol'">
					HDL "Good" Cholesterol
				</div>
				<div class="row section-block-content">
					<div class="col-md-12">
						<span class="last-update-on" *ngIf="chartType.hasOwnProperty('HDL')">
							UPDATED: {{ chartType['HDL'].attributeUpdatedDate }}
						</span>
					</div>
					<div [className]="appUtil.isScreenSizeIpad() ? 'col-md-4' : 'col-md-3'">
						<app-progress-bar
							class="HDL"
							*ngIf="chartType.hasOwnProperty('HDL') && renderCharts === true"
							[chartData]="chartType['HDL']"></app-progress-bar>
					</div>
					<div [className]="appUtil.isScreenSizeIpad() ? 'col-md-8' : 'col'">
						<span *ngIf="chartType.hasOwnProperty('HDL') !== true"> Your lab results are not available </span>
						<p *ngIf="chartType.hasOwnProperty('HDL')">{{ chartType['HDL'].metricDescription }}</p>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="section-wrapper">
		<div>
			<div class="section-block">
				<div class="section-block-header" [translate]="'wellness.lab-results.triglycerides'">Triglycerides</div>
				<div class="row section-block-content">
					<div class="col-md-12">
						<span class="last-update-on" *ngIf="chartType.hasOwnProperty('Triglycerides')">
							UPDATED: {{ chartType['Triglycerides'].attributeUpdatedDate }}
						</span>
					</div>
					<div [className]="appUtil.isScreenSizeIpad() ? 'col-md-4' : 'col-md-3'">
						<app-progress-bar
							class="Triglycerides"
							*ngIf="chartType.hasOwnProperty('Triglycerides') && renderCharts === true"
							[chartData]="chartType['Triglycerides']"></app-progress-bar>
					</div>
					<div [className]="appUtil.isScreenSizeIpad() ? 'col-md-8' : 'col'">
						<span *ngIf="chartType.hasOwnProperty('Triglycerides') !== true"> Your lab results are not available </span>
						<p *ngIf="chartType.hasOwnProperty('Triglycerides')">{{ chartType['Triglycerides'].metricDescription }}</p>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="section-wrapper">
		<div>
			<div class="section-block">
				<div class="section-block-header" [translate]="'wellness.lab-results.diabetes'">Diabetes - Hemoglobin A1c</div>
				<div class="row section-block-content">
					<div class="col-md-12">
						<span class="last-update-on" *ngIf="chartType.hasOwnProperty('Hemoglobin-A1C')">
							UPDATED: {{ chartType['Hemoglobin-A1C'].attributeUpdatedDate }}
						</span>
					</div>
					<div [className]="appUtil.isScreenSizeIpad() ? 'col-md-4' : 'col-md-3'">
						<app-progress-bar
							class="Hemoglobin-A1C"
							*ngIf="chartType.hasOwnProperty('Hemoglobin-A1C') && renderCharts === true"
							[chartData]="chartType['Hemoglobin-A1C']"></app-progress-bar>
					</div>
					<div [className]="appUtil.isScreenSizeIpad() ? 'col-md-8' : 'col'">
						<span *ngIf="chartType.hasOwnProperty('Hemoglobin-A1C') !== true">
							Your lab results are not available
						</span>
						<p *ngIf="chartType.hasOwnProperty('Hemoglobin-A1C')">
							{{ chartType['Hemoglobin-A1C'].metricDescription }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</div>
